export default __webpack_public_path__ + "static/media/Logo-final.7344c201.png";